// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  ADD_SOILJOB,
  EDIT_SOILJOB,
  ADD_TABLE_SOILJOB,
  EDIT_TABLE_SOILJOB,
  DELETE_TABLE_SOILJOB,
  SELECT_SOIL_JOB,
} from './constants'

export function addSoilJob (userId: ?number, subfieldId: ?number): Action<> {
  return {
    type: ADD_SOILJOB,
    payload: {
      userId: userId,
      subfieldId: subfieldId,
    },
  }
}

export function addTableSoilJob (userId: ?number, subfieldId: ?number): Action<> {
  return {
    type: ADD_TABLE_SOILJOB,
    payload: {
      userId: userId,
      subfieldId: subfieldId,
    },
  }
}

export function editSoilJob (job: Object): Action<> {
  return {
    type: EDIT_SOILJOB,
    payload: job,
  }
}

export function editTableSoilJob (job: Object): Action<> {
  return {
    type: EDIT_TABLE_SOILJOB,
    payload: job,
  }
}

export function deleteTableSoilJob (job: Object): Action<> {
  return {
    type: DELETE_TABLE_SOILJOB,
    payload: job,
  }
}

export const selectSoilJob = function (jobId: number): Action<void> {
  return {
    type: SELECT_SOIL_JOB,
    payload: jobId,
  }
}
